/**
 * Normalize a Dutch postal code for display and comparison: trim, upper-case and
 * strip all whitespace (e.g. "1234 ab" -> "1234AB"). Returns an empty string for
 * empty/nullish input.
 */
export const normalisePostalCode = (v: string | null | undefined): string =>
  v ? v.trim().toUpperCase().replace(/\s+/g, "") : "";
